import styled from "@emotion/styled"
import getMediaQuery from "css/breakpoints"
import { wv_willfade } from "./../styles"
import { headline70, headline30, body50, bold, visuallyHidden } from "css/text"
import { buttonReset } from "css/buttons"

export const Main = styled.nav`
  grid-row: 1;
  grid-column: 1/-1;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding-block: 1.25rem;
  --toggle-button-height: 4.375rem;
  --toggle-image-offset: -0.7rem;

  ${getMediaQuery("xl")} {
    display: none;
  }

  & button {
    position: relative;
    height: var(--toggle-button-height);
    width: 6.75rem;
    border: 0;
    background-color: #e8e8e8;
    display: grid;
    justify-items: center;
    border-radius: 0.625rem;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      bottom: -0.75rem;
      width: 0.4375rem;
      height: 0.4375rem;
      border-radius: 0.4375rem;
      background: rgb(var(--green));
      transition: opacity 0.3s;
    }

    &.cfg-toggle-off::after {
      opacity: 0;
    }

    & img {
      transition: opacity 400ms cubic-bezier(0.61, 1, 0.88, 1) 0ms;
    }

    & > img {
      position: absolute;
      width: auto;
      top: var(--toggle-image-offset);
      height: calc(var(--toggle-button-height) * 1.2);
      -webkit-user-drag: none;
      object-fit: cover;
    }

    & section figure {
      position: absolute;
      width: 100%;
      top: var(--toggle-image-offset);
      height: calc(var(--toggle-button-height) * 1.2);
      will-change: opacity;

      animation-fill-mode: both;
      animation-name: wvwrfadeout;
      animation-duration: 0ms;
      animation-timing-function: cubic-bezier(0.61, 1, 0.88, 1);
      animation-delay: var(--wv-roller-swap-duration);

      &.wv_reveal {
        animation-name: wvwrfadein;
        animation-duration: var(--wv-roller-swap-duration);
        animation-delay: 0ms;
      }

      &:nth-of-type(1) {
        display: none;
      }

      img {
        -webkit-user-drag: none;
        pointer-events: none;
        position: relative;
        object-fit: cover;
        height: 100%;
        width: auto;
      }
    }
  }
`
